import React from "react";
import PropTypes from "prop-types";

const TextInput = ({ onChange, value = "", ...rest }) => (
  <input className="et--text-input" type="text" onChange={e => onChange(e.target.value)} value={value} {...rest} />
);

TextInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default TextInput;
